export default interface ITobaccoAssessment {
    HasTobaccoUse?: boolean;
    HasCigrettesUse?: boolean;
    IsChewingTobacco?: boolean;
    IsVaping?: boolean;
    TobaccoUseInYears?: number;
    IsInterestedInQuitting?: boolean;
    AverageToboccoUsagePerDay?: number;
    IsAIHasTobaccoUse?: boolean;
    IsAIHasCigrettesUse?: boolean;
    IsAIChewingTobacco?: boolean;
    IsAIVaping?: boolean;
    IsAITobaccoUseInYears?: boolean;
    IsAIInterestedInQuitting?: boolean;
    IsAIAverageTobaccoUsagePerDay?: boolean;
}

export class TobaccoAssessment implements ITobaccoAssessment {
    HasTobaccoUse?: boolean;
    HasCigrettesUse?: boolean;
    IsChewingTobacco?: boolean;
    IsVaping?: boolean;
    TobaccoUseInYears?: number;
    IsInterestedInQuitting?: boolean;
    AverageToboccoUsagePerDay?: number;
    IsAIHasTobaccoUse?: boolean;
    IsAIHasCigrettesUse?: boolean;
    IsAIChewingTobacco?: boolean;
    IsAIVaping?: boolean;
    IsAITobaccoUseInYears?: boolean;
    IsAIInterestedInQuitting?: boolean;
    IsAIAverageTobaccoUsagePerDay?: boolean;

    constructor() {
        this.HasTobaccoUse = null;
    }
}
